export default __webpack_public_path__ + "static/media/qt-white.c1dc8887.svg";